module.exports = __webpack_public_path__ + "static/media/nl.9bfd784c.svg";